<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
        <div class="col-md-12">
          <div class="top-list-toolbar">
            <div>
              <h4 class="text-primary">Table</h4>
              <ol class="breadcrumb breadcrumb-card-header">
                <li class="breadcrumb-item">
                  <a href="javascript:void(0);" @click="backParent">Table</a>
                </li>
                <li class="breadcrumb-item active">
                  <span v-if="table.id === null">New</span>
                  <span v-else>
                    {{ table.table_no }}
                  </span>
                </li>
              </ol>
              <button type="button" @click="updateTable" class="btn btn-sm btn-soft-primary pull-left" v-show="table.id !== null"><i class="fa fa-check" aria-hidden="true"></i> Update</button>
              <button type="button" @click="saveTable" class="btn btn-sm btn-soft-primary pull-left" v-show="table.id == null"><i class="fa fa-check" aria-hidden="true"></i> Create</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <!-- card1 -->
        <div class="col-md-12">
          <div class="card card-list">
            <div class="card-header">
              <div class="col-md-12">
                <h5 class="text-primary">
                  <span v-if="table.id === null">New</span>
                  <span v-else>{{ table.table_no }}</span>
                </h5>
              </div>
            </div>
            <div class="card-body">
              <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="alert.length > 0">
                <ul v-for="(a, index) in alert" :key="index">
                  <li v-html="a"></li>
                </ul>
              </div>
              <div class="row">
                  <div class="col-md-4">
                    <dl class="row dl-custom font-12">
                      <dt class="col-md-4">Alias</dt>
                      <dd class="col-md-8">
                        <input type="text" class="form-control form-control-lite" v-model="table.alias" />
                      </dd>
                      <dt class="col-md-4">Company</dt>
                      <dd class="col-md-8">
                        <select v-model="table.company_no" class="form-control">
                            <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                        </select>
                      </dd>
                      <dt class="col-md-4">Asset</dt>
                      <dd class="col-md-8">
                      </dd>
                      <dt class="col-md-4">Notes</dt>
                      <dd class="col-md-8">
                        <textarea class="form-control form-control-lite" v-model="table.notes" rows="5"></textarea>
                      </dd>
                    </dl>
                  </div>
              </div>
              <hr>
              <div class="row">
                <div class="col-md-12">
                  <ul class="nav nav-tabs nav-bordered">
                    <li class="nav-item">
                      <a href="#expense" data-toggle="tab" aria-expanded="false" class="nav-link active">Expense</a>
                    </li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane active" id="expense">
                      <table class="table table-sm table-item table-hover table-striped">
                            <thead>
                                <th style="width: 30%">Product</th>
                                <th>Qty</th>
                                <th>Uom</th>
                                <th>Price</th>
                                <th class="text-right">Total</th>
                                <th>#</th>
                            </thead>
                            <tbody>
                                <tr v-for="(e, index) in table.expenses" :key="index">
                                    <td>
                                        <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="e.product_no" @input="setProduct(index)" />
                                    </td>
                                    <td>
                                        <input type="text" class="form-control" v-model="e.qty"   v-on:keyup="calcRowTotal(index)" />
                                    </td>
                                    <td>
                                        <select v-model="e.uom_id" class="form-control">
                                            <option v-for="a in e.uomList" :key="a.id" :value="a.id">{{ a.name }}</option>
                                        </select>
                                    </td>
                                    <td>
                                        <input type="text" v-money="money" class="form-control" v-model="e.price" v-on:keyup="calcRowTotal(index)"/>
                                    </td>
                                    <td class="text-right">{{ e.total | currency}}</td>
                                    <td>
                                        <button type="button" class="btn btn-sm btn-soft-outline-danger" @click="removeExpense(index)">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span @click="addExpenseLine" class="link-secondary">+ Add Line</span></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right"><b>{{ totalExpense | currency }}</b></td>
                                </tr>
                            </tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row justify-content-md-center">
        <div class="col-md-6">
          <h5>Logs:</h5>
          <div class="alert alert-info" role="alert" v-for="l in purchasing.logs" :key="l.id">
            <b>{{ l.user }}</b> - {{ l.log_date | dateFormat('DD/MM/YYYY HH:mm:ss') }} <span>"{{ l.description }}"</span>
          </div>
        </div>
      </div> -->
      <!-- <pre>{{ settingTaxRound }}</pre> -->
      <!-- <pre>{{ settingList }}</pre> -->
      <pre>{{ totalProductList }}</pre>
      <pre>{{ dataCollect }}</pre>
      <!-- <pre>{{ vendorSelect }}</pre> -->
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { getHeader, productUrl, tableUrl } from '../../config'

export default {
  name: 'TableForm',
  props: ['table'],
  components: {
    Loading
  },
  data () {
    return {
      alert: [],
      vendorNo: null,
      inventoryData: {},
      selectQty: false,
      searchQueryInventory: '',
      searchQueryOrder: '',
      card1: 'col-md-12',
      card2: null,
      ref: null,
      refNo: null,
      idDetail: null,
      detail: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  created () {
    this.ref = this.$route.query.ref
    this.refNo = this.$route.query.refNo
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      productListSelect: state => state.products.productListSelect,
      uomList: state => state.uom.uomList,
      companyList: state => state.companies.companyList
    }),
    totalProductList () {
      return this.productListSelect.length
    },
    dataCollect () {
      var array = this.table.expenses
      var expColl = []
      for (let i = 0; i < array.length; i++) {
        var obj = {}
        if (typeof array[i].id === 'undefined') {
          obj = {
            table_no: array[i].table_no,
            product_no: array[i].product_no,
            qty: array[i].qty,
            uom_id: array[i].uom_id,
            price: array[i].price.replace(/\./g, ''),
            subtotal: array[i].subtotal,
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            total: array[i].total,
            notes: array[i].notes,
            company_no: array[i].company_no
          }
        } else {
          obj = {
            id: array[i].id,
            table_no: array[i].table_no,
            product_no: array[i].product_no,
            qty: array[i].qty,
            uom_id: array[i].uom_id,
            price: array[i].price.replace(/\./g, ''),
            subtotal: array[i].subtotal,
            tax_id: array[i].tax_id,
            tax: array[i].tax,
            total: array[i].total,
            notes: array[i].notes,
            company_no: array[i].company_no
          }
        }
        expColl.push(obj)
      }
      var data = {
        id: this.table.id,
        table_no: this.table.table_no,
        alias: this.table.alias,
        notes: this.table.notes,
        asset_no: this.table.asset_no,
        company_no: this.table.company_no,
        expenses: expColl
      }
      return data
    },
    totalExpense () {
      var sum = 0
      var array = this.table.expenses
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    productselect () {
      var loop = []
      var array = this.productListSelect
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: '[' + array[x].product_no + '] ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    async setProduct (index) {
      var exp = this.table.expenses[index]
      var product = this.productListSelect.find(d => d.product_no === exp.product_no)
      var body = {
        product_no: exp.product_no
      }
      await axios.post(productUrl + '/uom/list', body, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          exp.uomList = response.data.data
          exp.uom_id = product.uom_id
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async removeExpense (index) {
      var detail = this.table.expenses[index]
      if (typeof detail.id === 'undefined') {
        this.table.expenses.splice(index, 1)
      } else {
        await this.$swal.fire({
          title: 'Are you sure Delete this?',
          text: "You won't be able to revert this!",
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
          if (result.value) {
            axios.delete(tableUrl + '/expense/' + detail.id, { headers: getHeader() })
              .then(response => {
                this.table.expenses.splice(index, 1)
              })
              .catch(error => {
                console.log(error)
                console.log(error.response.data.message)
                this.$swal('Error', error.response.data.message, 'error')
                throw error
              })
          }
        })
      }
    },
    addExpenseLine () {
      var obj = {
        table_no: null,
        product_no: null,
        qty: '1',
        uom_id: null,
        price: '0',
        subtotal: '0',
        tax_id: null,
        tax: '0',
        total: '0',
        notes: null,
        company_no: null,
        uomList: [{
          id: null,
          name: null,
          ratio: '0',
          category: null
        }]
      }
      console.log(obj)
      this.table.expenses.push(obj)
    },
    calcRowTotal: function (index) {
      var exp = this.table.expenses[index]
      var qty = parseFloat(exp.qty)
      var price = parseFloat(exp.price.replace(/\./g, ''))
      exp.total = qty * price
    },
    backParent: function () {
      this.alert = []
      this.$emit('backClicked')
    },
    async saveTable () {
      await axios.post(tableUrl, this.dataCollect, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Success', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response.data.message)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async updateTable () {
      await axios.put(tableUrl + '/' + this.table.id, this.dataCollect, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$swal('Success', response.data.message, 'success')
          this.backParent()
        })
        .catch(error => {
          console.log(error)
          console.log(error.response.data.message)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>

<style>
  .flex {
    display: flex;
    flex-direction: row;
  }
</style>
